import React from "react";
import './PortfolioDesign.css';

import { useTranslation } from "react-i18next"; //translator
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Pagination } from "swiper";
import "swiper/css/pagination";

import pic1 from './PfPics/1.png';
import pic3 from './PfPics/3.png';
import pic4 from './PfPics/4.png';
import pic5 from './PfPics/5.png';
import pic6 from './PfPics/6.png';
import pic7 from './PfPics/7.png';
import pic8 from './PfPics/8.png';
import pic9 from './PfPics/9.png';
import pic10 from './PfPics/10.png';
import pic101 from './PfPics/101.png';
import pic102 from './PfPics/102.png';
import pic11 from './PfPics/11.png';
import pic12 from './PfPics/12.png';
import pic122 from './PfPics/12-2.png';
import pic13 from './PfPics/13.png';
import pic14 from './PfPics/14.png';
import pic15 from './PfPics/15.png';
import pic16 from './PfPics/16.png';
import pic17 from './PfPics/17.png';
import pic18 from './PfPics/18.png';
import pic19 from './PfPics/19.png';
import pic20 from './PfPics/20.png';
import pic21 from './PfPics/21.png';
import pic22 from './PfPics/22.png';
import pic23 from './PfPics/23.png';
import pic24 from './PfPics/24.png';
import pic25 from './PfPics/25.png';
import pic26 from './PfPics/26.png';
import pic27 from './PfPics/27.png';
import pic28 from './PfPics/28.png';
import pic29 from './PfPics/29.png';
import pic30 from './PfPics/30.png';
import pic31 from './PfPics/31.png';
import pic32 from './PfPics/32.png';
import pic33 from './PfPics/33.png';
import pic34 from './PfPics/34.png';
import pic35 from './PfPics/35.png';
import pic36 from './PfPics/36.png';
import pic37 from './PfPics/37.png';



const PortfolioDesign = () => {
  const [t] = useTranslation("global");
  const pics = [pic1,pic3, pic4, pic5,pic6, pic7,pic8, pic9, pic10,pic101,pic102, pic11, pic12,pic122, pic13, pic14, pic15, pic16, pic17, pic18, pic19, pic20, pic21, pic22, pic23, pic24, pic25, pic26, pic27, pic28, pic29, pic30, pic31, pic32, pic33, pic34, pic35, pic36, pic37

  ];

    return(
      <div className="pt-wrapper" id="Portfolio">
        <div className="pt-heading">
          <span>{t("Portfolio.title.1")}</span> 
          <span> {t("Portfolio.title.2")} </span>
          <div className="blur t-blur1" style={{ background: "var(--yellow)" }}></div>
          <div  className="blur t-blur2" style={{ background: "orange" }}></div>
        
  
        </div>

        <Swiper
          
          // install Swiper modules
          modules={[Pagination]}
          slidesPerView={1}
          pagination={{ clickable: true  } }
        >
          {pics.map((pics, index) => {
            return (
              <SwiperSlide key={index}>
                <div className="ptestimonial">

                  <img className="pics" src={pics} alt="" />
               
                 
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
        
      </div>
    );
};

export default PortfolioDesign; 